import React from 'react';
import PricingSection from '@/components/PricingSection';

// Public embed configuration supplied from the Stripe Dashboard.
// Load the embed script only when the landing pricing table needs it.
const LIVE_PRICING_TABLE_ID = 'prctbl_1UAsJ7HlVVSVFAdGlAaSYTM6';
const LIVE_STRIPE_PUBLISHABLE_KEY = 'pk_live_51TGvrOHlVVSVFAdG5bdOnbCbnkBorbE5cv0vOasb82exRryyUFSAH3NzNr59qxwdBttwgQonlKFl4AYW5BEt3TFz00QwwZofrv';

const environment = import.meta.env.VITE_ENVIRONMENT?.trim().toLowerCase();
const isProduction = environment === 'prod' || environment === 'production';

// Only production may fall back to the live table; every other environment must
// configure its own (test-mode) table or it renders the API-driven plans instead.
const pricingTableId = import.meta.env.VITE_STRIPE_PUBLIC_PRICING_TABLE_ID?.trim()
  || (isProduction ? LIVE_PRICING_TABLE_ID : '');
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY?.trim()
  || (isProduction ? LIVE_STRIPE_PUBLISHABLE_KEY : '');

const PublicStripePricingSection: React.FC = () => {
  React.useEffect(() => {
    if (!pricingTableId || !publishableKey) return;
    const src = 'https://js.stripe.com/v3/pricing-table.js';
    if (document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  }, []);

  if (!pricingTableId || !publishableKey) return <PricingSection />;
  return (
    <section id="pricing" aria-label="Pricing" className="scroll-mt-24 bg-white py-12 sm:py-16">
      <div className="mx-auto w-full max-w-[82rem] px-4 sm:px-8">
        <stripe-pricing-table
          pricing-table-id={pricingTableId}
          publishable-key={publishableKey}
        />
      </div>
    </section>
  );
};

export default PublicStripePricingSection;
